import React from "react";

export default function CommonSlider({ sliderData }) {
    if (!sliderData) return null;

    const isGroupon = !!sliderData.advertiserName;

    const truncate = (text, max = 30) => {
        if (!text) return "";
        return text.length > max ? text.slice(0, max) + "..." : text;
    };

    const title =
        sliderData.name ||
        sliderData.title;

    const image =
        sliderData.image_url ||
        sliderData.imageLink;

    const link =
        sliderData.url ||
        sliderData.link ||
        sliderData.linkCode?.clickUrl;

    const categories = sliderData.categories || [];
    const description = sliderData.description || [];
    const location = sliderData.location;

    // const priceObj = isGroupon
    //     ? sliderData.salePrice ? sliderData.salePrice : sliderData.price   // 👈 Groupon: { amount, currency }
    //     : sliderData.price;

    // const getPriceText = (price) => {
    //     if (!price) return null;

    //     // Groupon
    //     if (typeof price === "object" && price.amount) {
    //         return `${price.currency} ${price.amount}`;
    //     }

    //     // Yelp
    //     if (typeof price === "string") {
    //         return price;
    //     }

    //     return null;
    // };

    // const priceText = getPriceText(priceObj);
    const categoryText = categories.map(c => c.title).join(", ");


    return (
        <div className="resorts-box p-3 bg-white">
            <figure>
                <img
                    src={image}
                    alt={title}
                    className="img-fluid"
                    loading="lazy"
                />
            </figure>

            <div className="resorts-content-box">
                {/* Rating (Yelp only) */}
                {sliderData.rating && (
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="rating-star">
                            <i className="fa-solid fa-star"></i>{" "}
                            {sliderData.rating}
                            {sliderData.review_count && (
                                <small className="ms-1">
                                    ({sliderData.review_count})
                                </small>
                            )}
                        </span>

                        {/* {priceText && (
                            <div className="price-tag mb-1">
                                {priceText}
                            </div>
                        )} */}
                    </div>
                )}

                {/* Title */}
                <div className="resort-description border-0 m-0 pb-1">
                    <h3 className="mt-2">{truncate(title, 30)}</h3>
                </div>

                {/* Categories (Yelp only) */}
                {description && (
                    <p className="text-muted small mt-0 mb-1">
                        {truncate(description, 30)}
                    </p>
                )}
                {categories.length > 0 && (
                    <p
                        className="text-muted small mt-0 mb-1"
                        title={categoryText}   // 👈 hover pe full text
                    >
                        {truncate(categoryText, 30)}
                    </p>
                )}

                {/* Location */}
                {location?.display_address && (
                    <p className="text-muted small">
                        {location.display_address.join(", ")}
                    </p>
                )}

                {/* CTA */}
                <div className="book-trip-btn mt-2">
                    <a
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-100 text-center d-block"
                    >
                        {isGroupon ? "View Deal" : "View on Yelp"}
                    </a>
                </div>
            </div>
        </div>
    );
}
